<template>
  <div>
    <h4 class="card-title text-center">{{ $t('login.register_success') }}</h4>
    <p class="card-text">{{ $t('login.register_success_message') }}</p>
    <div class="text-center">
      <router-link
        :to="{ name: 'login' }"
        class="btn btn-info"
        aria-expanded="false"
      >
        {{ $t('login.sign_in') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import LinkButton from "@/components/Misc/LinkButton";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "RegisterSuccess",
  components: {
    LinkButton,
  },
  beforeMount() {
  },
  computed: {
    ...mapGetters({
    }),
    
  },
  methods: {
    ...mapActions({
    }),
  }
};
</script>
